import { gql } from "@apollo/client";

/**
 * @deprecated Shared fragment types are deprecated. Use or pick from generated types instead.
 */
interface DosageFormatFragment {
  id: string;
  baseFormat: string;
  variation: string;
}

/**
 * @deprecated Shared fragments are deprecated. Indicate field name directly within query/mutation or
 * create a co-located (not shared) fragment, if you need one.
 */
const DOSAGE_FORMAT_FRAGMENT = gql`
  fragment DosageFormatFragment on DosageFormat {
    id
    baseFormat
    variation
  }
`;

export type { DosageFormatFragment };
export { DOSAGE_FORMAT_FRAGMENT };
